/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from '@reduxjs/toolkit';
import ratesReducer from './campground-rates';
import campgroundReducer from './campground-campground';
import recareaReducer from './campground-recareas';

const campgroundReducers = {
    campground: campgroundReducer,
    rates: ratesReducer,
    recreationSites: recareaReducer,
};

export default combineReducers(campgroundReducers);
